import { render, staticRenderFns } from "./temptable.vue?vue&type=template&id=5c513508&"
import script from "./temptable.vue?vue&type=script&lang=js&"
export * from "./temptable.vue?vue&type=script&lang=js&"
import style0 from "./temptable.vue?vue&type=style&index=0&id=5c513508&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports